const API_BASE_URL = (process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api').replace(/\/$/, '');

export async function apiRequest(path, options = {}) {
  const response = await fetch(`${API_BASE_URL}${path}`, {
    credentials: 'include', ...options,
    headers: { Accept: 'application/json', ...(options.body ? { 'Content-Type': 'application/json' } : {}), ...(options.token ? { Authorization: `Bearer ${options.token}` } : {}), ...options.headers }
  });
  const body = await response.json().catch(() => null);
  if (!response.ok) {
    const error = new Error(body?.error?.message || 'Unable to complete your request.');
    error.code = body?.error?.code || 'REQUEST_FAILED';
    error.details = body?.error?.details || {};
    error.status = response.status;
    throw error;
  }
  return body.data;
}

export { API_BASE_URL };
